import { fetchPageData } from "../utils/fetch";

export const getAbout = async () => {
  const endpoint = "about";
  const method = "GET";
  const err = "Failed to fetch about.";
  const fetchedData = await fetchPageData(endpoint, method, err);
  return fetchedData;
};

export const updateAbout = async (token, aboutData) => {
  const endpoint = "about";
  const err = "Editing about failed.";
  const method = "PUT";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    token,
    aboutData
  );
  return fetchedData;
};

// export const deleteabout = async (token, aboutId) => {
//   const endpoint = `about/${aboutId}`;
//   const method = "DELETE";
//   const err = "Deleting about failed.";
//   const fetchedData = await fetchPageData(endpoint, method, err, token);
//   return fetchedData;
// };
